

export default function Hr({ borderColor = "title", opacity = "20" }) {
    return (
        <hr className={`border border-solid border-${borderColor} opacity-${opacity} my-5`} />
    )
};